<script>
	import UIIcon from "./UIIcon.svelte";
	import view from "../stores/view";
	export let icon = "";
	export let home = false;
</script>

<button class="UIButton" on:click class:_home={home}>
	<span><slot /></span>
	<UIIcon type={icon} size={$view.mode === "pc" ? 24 : 20} />
</button>

<style global>
	.UIButton {
		border: 1px solid #bb5858;
		box-shadow: 0 2px 0 rgba(187, 88, 88, 0.1);
		appearance: none;
		background: #fff;
		color: #bb5858;
		padding: 0.5em 0.5em;
		border-radius: 10em;
		text-align: center;
		min-width: 280px;
		cursor: pointer;
		transition: background 100ms linear;
		position: relative;
		margin-right: auto;
		margin-left: auto;
		font-size: 0.9em;
	}
	:global(.pc) .UIButton {
		min-width: 320px;
		font-size: 1em;
	}
	.UIButton._home {
		min-width: 240px;
		max-width: auto;
	}
	:global(.pc) .UIButton._home {
		min-width: 100%;
		max-width: 310px;
	}
	@media screen and (min-width: 1200px) {
		:global(.pc) .UIButton._home {
		min-width: 310px;
	}
	}
	:global(.pc) .UIButton:hover {
		background: #bb5858;
		color: #fff;
	}
	.UIButton:focus-visible {
		border: 1px dashed #d77;
	}
	.UIButton > span {
		display: inline-block;
		font-size: 1.5em;
	}
	.UIButton > svg {
		margin-top: 0.2em;
		position: absolute;
		top: 1em;
		right: 1.25em;
		stroke: #bb5858 !important;
	}
	:global(.pc) .UIButton:hover > svg {
		stroke: #fff !important;
	}
	.UIButton :global(small) {
		font-size: 0.75em;
	}
</style>
